<template>
	<div class="cart-overview__total-wrapper">
		<div class="cart-overview__total">
			<h4 class="cart-overview__total-title">
				{{ $t('cart.overviewTitle') }}
				<span v-if="cart.resvid" class="cart-overview__total-id">
					({{ cart.resvid }})
				</span>
			</h4>

			<div class="cart-overview__wrapper-acc">
				<!-- Accommodation -->
				<template v-if="cart.accommodation.length">
					<div
						class="cart-overview__total-acc"
						v-for="(accommodation, index) in cart.accommodation"
						:key="accommodation.objectId"
					>
						<span>
							<span class="cart-overview__count">
								{{ $t('accommodation.accommodation') }} {{ index + 1 }}
							</span>
							<span class="cart-overview__title">
								{{ accommodation.title }}
							</span>
						</span>
						<span>
							{{ totalAccPrice(accommodation.poollid, accommodation.unitlid) }}
							{{ cart.currency }}
						</span>
					</div>
				</template>

				<!-- Skipass -->
				<div class="cart-overview__total-acc" v-if="cart.skipass.length">
					<span>
						{{ cart.skipass.length }} × {{ $t('skipass.skipass') }}
						<!-- <template v-if="">(inkl keycards ?×{{ convertPrice(cart.keycardPrice) }} {{ cart.currency }})</template> -->
					</span>
					<!-- <span>{{ totalPriceOf(['skipass']) }} {{ cart.currency }}</span> -->
					<span>{{ totalFullPriceOf(['skipass']) }} {{ cart.currency }}</span>
				</div>

				<!-- Skirental -->
				<div class="cart-overview__total-acc" v-if="cart.skirental.length">
					<span>
						{{ cart.skirental.length }} × {{ $t('skirental.skirental') }}
						<template v-if="cart.delivery">
							<!-- ({{ $t('cart.includingDelivery') }} -->
							<!-- {{ convertPrice(cart.deliveryPrice) }} {{ cart.currency }}) -->
						</template>
					</span>
					<span>{{ totalPriceOf(['skirental']) }} {{ cart.currency }}</span>
				</div>

				<!-- Skischool -->
				<div class="cart-overview__total-acc" v-if="cart.skischool.length">
					<span>
						{{ cart.skischool.length }} × {{ $t('skischool.skischool') }}
					</span>
					<span>{{ totalPriceOf(['skischool']) }} {{ cart.currency }}</span>
				</div>

				<!-- Activities -->
				<div class="cart-overview__total-acc" v-if="cart.activities.length">
					<span>
						{{ cart.activities.length }} × {{ $t('activities.activities') }}
					</span>
					<span>{{ totalPriceOf(['activities']) }} {{ cart.currency }}</span>
				</div>

				<!-- Discount -->
				<div
					class="cart-overview__total-acc"
					v-if="hasDiscount && !cart.resvid"
				>
					<span>{{ $t('cart.discount') }}</span>
					<span class="price price--discount">
						-{{ formatMoney(totalDiscountPrice()) }} {{ cart.currency }}
					</span>
				</div>
			</div>

			<!-- Total price -->
			<!-- If editing booking -->

			<div v-if="cart.payedamount" class="cart-overview__payedamount">
				<div>
					<span>{{ $t('cart.total') }}:</span>
					<span class="font-weight-medium">
						{{
							totalPriceOf([
								'skipass',
								'skirental',
								'skischool',
								'accommodation',
								'activities'
							])
						}}
						{{ cart.currency }}
					</span>
				</div>
				<div>
					<span>{{ $t('cart.paidAmount') }}:</span>
					<span class="font-weight-medium">
						-{{ formatMoney(cart.payedamount) }} {{ cart.currency }}
					</span>
				</div>
				<div>
					<h4 class="cart-overview__total-price">
						<span>{{ $t('cart.amountToPay') }}:</span>
						<span class="heading heading--large font-weight-medium">
							{{
								formatMoney(
									parseInt(
										totalPriceOf([
											'skipass',
											'skirental',
											'skischool',
											'accommodation',
											'activities'
										]).replace(/[^0-9.]/g, '')
									) - cart.payedamount
								)
							}}
							{{ cart.currency }}
						</span>
					</h4>
				</div>
			</div>

			<h4
				class="cart-overview__total-price heading heading--large font-weight-medium"
				v-else-if="isEmptyCart() && cart.resvid"
			>
				{{
					totalPriceOf([
						'skipass',
						'skirental',
						'skischool',
						'accommodation',
						'activities'
					])
				}}
				{{ cart.currency }}
				<!-- <p>From booking: {{ cart.totalamounttopay }} {{ cart.currency }}</p> -->
			</h4>

			<!-- Total price -->
			<h4
				class="cart-overview__total-price heading heading--large font-weight-medium"
				v-else-if="isEmptyCart() && !cart.resvid"
			>
				{{
					totalPriceOf([
						'skipass',
						'skirental',
						'skischool',
						'accommodation',
						'activities'
					])
				}}
				{{ cart.currency }}
			</h4>

			<!-- Empty cart text -->
			<h5 v-else>{{ $t('cart.emptyTitle') }}</h5>

			<!-- Log in to pay text -->
			<h5 v-if="!isLoggedIn() && isEmptyCart() && !isFastCheckout()">
				{{ $t('cart.loginToPay') }}
			</h5>

			<!-- Booking terms  -->
			<div
				v-if="
					(isLoggedIn() && isEmptyCart()) || (isFastCheckout() && isEmptyCart())
				"
				class="cart-overview__booking-terms"
			>
				<Checkbox
					:lightTheme="true"
					:small="true"
					:isChecked="this.acceptedBookingTerms"
					:label="$t('cart.acceptBookingTerms')"
					@check-input="
						val => {
							this.acceptedBookingTerms = val
						}
					"
				/>
			</div>

			<!-- Checkout button -->
			<div
				v-if="
					(isLoggedIn() && isEmptyCart()) || (isFastCheckout() && isEmptyCart())
				"
				class="cell small-12 medium-12 large-12"
			>
				<Button
					@click.native="!disabelConfirm() ? beforeConfirm() : () => {}"
					:full="true"
					:disabled="disabelConfirm()"
					:loading="loading"
				>
					{{ $t('cart.checkout') }}
				</Button>
				<div v-if="!cart.everytingIsValid && cart.cartCheckoutClicked">
					<br />
					<p class="colorRed">{{ $t('cart.validationErrorText') }}</p>
				</div>

				<!-- <div v-if="!keynumberValid">
					<p>Ett eller fler Keycard nummer är inte giltig</p>
				</div> -->
				<!--<router-link :to="{ name: 'payment' }">
				</router-link>-->
				<p class="cart-overview__payment-info meta">
					{{ $t('cart.checkoutinfo') }}
				</p>
				<Button
					v-if="cart.resvid"
					@click.native="endChangeBooking"
					:full="true"
					:disabled="false"
					:color="'red'"
				>
					Avsluta ändra bokning
				</Button>
			</div>

			<!-- Login/create account buttons -->
			<div class="cart-overview__profile grid-x grid-margin-x">
				<div v-if="!isLoggedIn() && !isFastCheckout()" class="cell small-6">
					<Button
						size="small"
						v-bind:full="true"
						@click.native="showLoginModal"
					>
						{{ $t('cart.login') }}
					</Button>
				</div>
				<div v-if="!isLoggedIn() && !isFastCheckout()" class="cell small-6">
					<router-link :to="{ name: 'newaccount' }">
						<Button size="small" color="dark" v-bind:full="true">
							{{ $t('cart.createAccount') }}
						</Button>
					</router-link>
				</div>
			</div>
		</div>
		<AlertMessage :show="false">
			<p>
				Vi upplever just nu en del störningar med vårt bokningssystem. Om du
				behöver hjälp med din bokning kontakta oss på:
			</p>
			<p>
				Telefon:
				<a href="tel:+4628096200">+46 280 - 96 200</a>
			</p>
		</AlertMessage>

		<!-- Payment logos -->
		<img
			class="cart-overview__payment-options"
			src="https://cdn.klarna.com/1.0/shared/image/generic/badge/xx_XX/checkout/short-blue.png?width=312"
			alt="payment"
		/>

		<Modal v-show="goToPaymentModal" :disableClose="true" :cover="true">
			<div class="cart-overview__go-to-payment">
				<Loading :dark="true" :dots="false" :large="true" />
				<h4>{{ $t('cart.redirectToPayment') }}</h4>
				<p v-html="$t('cart.redirectToPaymentText')"></p>
				<img
					class="cart-overview__payment-options"
					src="https://cdn.klarna.com/1.0/shared/image/generic/badge/xx_XX/checkout/short-blue.png?width=312"
					alt="payment"
				/>
			</div>
		</Modal>
		<Modal
			v-show="insuranceModal"
			:disableClose="false"
			@close="insuranceModal = false"
			:maxWidth="640"
		>
			<div class="cart-overview__go-to-payment">
				<h4>{{ $t('cart.cancellationInsurance') }}</h4>
				<p>{{ $t('cart.cancellationInsuranceReminder') }}</p>
				<div class="">
					<Button @click.native="addIncurence" :disabled="false">
						{{ $t('cart.cancellationInsuranceYes') }}
					</Button>
					<Button @click.native="confirm" :disabled="false">
						{{ $t('cart.cancellationInsuranceNo') }}
					</Button>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'

import Button from '../atoms/Button'
import Checkbox from '../atoms/Checkbox'
import Loading from '../atoms/Loading'
import AlertMessage from '../atoms/AlertMessage'
import Modal from '../molecules/Modal'

export default {
	name: 'CartOverview',
	mixins: [mixin],
	components: {
		Button,
		Checkbox,
		AlertMessage,
		Modal,
		Loading
	},
	props: {},
	data() {
		return {
			acceptedBookingTerms: false,
			loading: false,
			goToPaymentModal: false,
			insuranceModal: false
		}
	},
	computed: {
		cart() {
			return store.state.cart
		},
		user() {
			return store.state.user
		},
		guests() {
			if (store.state.user != null) {
				return store.state.user.guests
			}
			return []
		},
		hasDiscount() {
			for (let index = 0; index < this.cart.accommodation.length; index++) {
				const accommodation = this.cart.accommodation[index]

				if (
					(accommodation.promotion !== undefined &&
						accommodation.promotion !== null &&
						accommodation.promotion.promotioncode !== '') ||
					(accommodation.campaignCode !== undefined &&
						accommodation.campaignCode !== null &&
						accommodation.campaignCode !== '')
				) {
					return true
				}
			}

			return false
		}
	},
	created() {
		store.dispatch('CART_COMPLETE_CANCELLATION', false)
		store.dispatch('CART_CHECKOUT_CLICK', false)
		if (!this.cart.resvid) {
			store.dispatch('GTM_PUSH_REVIEW_CART', this.cart)
		}
	},
	methods: {
		endChangeBooking() {
			store.dispatch('EMPTY_CART')
		},
		showLoginModal() {
			store.dispatch('TOGGLE_GLOBAL_MODAL', { showLoginForm: true })
		},
		isLoggedIn() {
			return store.state.user != null
		},
		isEmptyCart() {
			return (
				this.cart.skipass.length ||
				this.cart.skirental.length ||
				this.cart.skischool.length ||
				this.cart.accommodation.length ||
				this.cart.activities.length
			)
		},
		isFastCheckout() {
			return store.state.cart.fastCheckout
		},
		disabelConfirm() {
			if (this.acceptedBookingTerms) {
				if (this.cart.cartCheckoutClicked) {
					return !this.cart.everytingIsValid
				}
				return false
			}
			return true
		},
		totalDiscountPrice() {
			let price = 0

			// accommodation
			for (let index = 0; index < this.cart.accommodation.length; index++) {
				const accommodation = this.cart.accommodation[index]

				if (
					(accommodation.promotion !== undefined &&
						accommodation.promotion !== null &&
						accommodation.promotion.promotioncode !== '') ||
					(accommodation.campaignCode !== undefined &&
						accommodation.campaignCode !== null &&
						accommodation.campaignCode !== '')
				) {
					price += accommodation.ordinaryprice - accommodation.price
				}
			}

			const skipassDiscount = this.totalDiscountPriceOf(['skipass'])
			price += skipassDiscount

			return price
		},
		totalAccPrice(poollid, unitlid) {
			const product = this.cart.accommodation.find(
				each => each.poollid == poollid && each.unitlid == unitlid
			)

			let price = parseInt(
				product.ordinaryprice !== -1 && !this.cart.resvid
					? product.ordinaryprice
					: product.price,
				10
			)

			if (product.addons) {
				for (let i = 0; i < product.addons.length; i++) {
					//If not included in price, add addon price
					if (product.addons[i].mandatory_web === false) {
						let addonPrice = parseInt(product.addons[i].aprice, 10)
						let addonQty = product.addons[i].qty
						price += addonPrice * addonQty
					}
				}
			}
			return new Intl.NumberFormat(this.$t('currency')).format(price)
		},
		totalPriceOf(typeArray) {
			let price = 0

			for (let index = 0; index < typeArray.length; index++) {
				const eachTypeArray = typeArray[index]

				if (this.cart.hasOwnProperty(eachTypeArray)) {
					for (let i = 0; i < this.cart[eachTypeArray].length; i++) {
						const eachProductArray = this.cart[eachTypeArray][i]

						price += parseInt(this.cart[eachTypeArray][i].price)

						//Accommodation addons
						if (eachProductArray.addons) {
							for (let i = 0; i < eachProductArray.addons.length; i++) {
								const eachAddon = eachProductArray.addons[i]
								//If not included in price, add addon price
								if (eachAddon.mandatory_web === false) {
									price += parseInt(eachAddon.aprice * eachAddon.qty)
								}
							}
						}

						//Keycards
						if (eachTypeArray == 'skipass' && eachProductArray.addrlid) {
							const selectedGuest = this.guests
								? this.guests.filter(function (item) {
										if (item.guestlid == eachProductArray.addrlid) {
											return item
										} // eslint-disable-next-line
								  })
								: []
							if (selectedGuest[0] && !selectedGuest[0].keynumber) {
								price += eachProductArray.keycardPrice
									? parseInt(eachProductArray.keycardPrice)
									: 0
							}
						}

						//Fast checkout keycard
						if (
							!this.isLoggedIn() &&
							this.cart.fastCheckout &&
							eachTypeArray == 'skipass' &&
							!eachProductArray.keynumber
						) {
							price += eachProductArray.keycardPrice
								? parseInt(eachProductArray.keycardPrice)
								: 0
						}

						//Delivery cost (once)
						if (eachTypeArray == 'skirental' && i == 0) {
							if (this.cart.delivery) {
								if (this.cart.deliveryPrice != -1) {
									price += this.cart.deliveryPrice
										? parseInt(this.cart.deliveryPrice)
										: 0
								}
							}
						}

						//Insurance
						if (
							eachProductArray.insurance &&
							eachProductArray.insurance == true
						) {
							price += parseInt(
								eachProductArray.priceWithInsurance - eachProductArray.price
							)
						}
					}
				}
			}

			return new Intl.NumberFormat(this.$t('currency')).format(price)
		},
		totalFullPriceOf(typeArray) {
			let price = 0

			for (let index = 0; index < typeArray.length; index++) {
				const eachTypeArray = typeArray[index]

				if (this.cart.hasOwnProperty(eachTypeArray)) {
					for (let i = 0; i < this.cart[eachTypeArray].length; i++) {
						const eachProductArray = this.cart[eachTypeArray][i]
						let p = 0

						if (
							eachProductArray.ordinaryPrice !== undefined &&
							eachProductArray.ordinaryPrice !== 0
						) {
							p = eachProductArray.ordinaryPrice
						} else if (
							eachProductArray.ordinaryprice !== undefined &&
							eachProductArray.ordinaryprice !== 0
						) {
							p = eachProductArray.ordinaryprice
						} else {
							// fallback to price
							p = eachProductArray.price
						}

						price += parseInt(p)

						//Accommodation addons
						if (eachProductArray.addons) {
							for (let i = 0; i < eachProductArray.addons.length; i++) {
								const eachAddon = eachProductArray.addons[i]
								//If not included in price, add addon price
								if (eachAddon.mandatory_web === false) {
									price += parseInt(eachAddon.aprice * eachAddon.qty)
								}
							}
						}

						//Keycards
						if (eachTypeArray == 'skipass' && eachProductArray.addrlid) {
							const selectedGuest = this.guests
								? this.guests.filter(function (item) {
										if (item.guestlid == eachProductArray.addrlid) {
											return item
										} // eslint-disable-next-line
								  })
								: []
							if (selectedGuest[0] && !selectedGuest[0].keynumber) {
								price += eachProductArray.keycardPrice
									? parseInt(eachProductArray.keycardPrice)
									: 0
							}
						}

						//Fast checkout keycard
						if (
							!this.isLoggedIn() &&
							this.cart.fastCheckout &&
							eachTypeArray == 'skipass' &&
							!eachProductArray.keynumber
						) {
							price += eachProductArray.keycardPrice
								? parseInt(eachProductArray.keycardPrice)
								: 0
						}

						//Delivery cost (once)
						if (eachTypeArray == 'skirental' && i == 0) {
							if (this.cart.delivery) {
								if (this.cart.deliveryPrice != -1) {
									price += this.cart.deliveryPrice
										? parseInt(this.cart.deliveryPrice)
										: 0
								}
							}
						}

						//Insurance
						if (
							eachProductArray.insurance &&
							eachProductArray.insurance == true
						) {
							price += parseInt(
								eachProductArray.priceWithInsurance - eachProductArray.price
							)
						}
					}
				}
			}

			return new Intl.NumberFormat(this.$t('currency')).format(price)
		},
		totalDiscountPriceOf(typeArray) {
			let price = 0

			for (let index = 0; index < typeArray.length; index++) {
				const eachTypeArray = typeArray[index]

				if (this.cart.hasOwnProperty(eachTypeArray)) {
					for (let i = 0; i < this.cart[eachTypeArray].length; i++) {
						const eachProductArray = this.cart[eachTypeArray][i]

						if (
							eachProductArray.promotion === undefined ||
							eachProductArray.promotion === null ||
							eachProductArray.promotion.promotioncode === undefined ||
							eachProductArray.promotion.promotioncode === null ||
							eachProductArray.promotion.promotioncode === ''
						) {
							continue
						}

						const ordinaryPrice =
							eachProductArray.ordinaryprice !== undefined &&
							eachProductArray.ordinaryprice !== null
								? eachProductArray.ordinaryprice
								: eachProductArray.ordinaryPrice
						price += parseInt(ordinaryPrice) - parseInt(eachProductArray.price)

						// //Accommodation addons
						// if (eachProductArray.addons) {
						// 	for (let i = 0; i < eachProductArray.addons.length; i++) {
						// 		const eachAddon = eachProductArray.addons[i]
						// 		//If not included in price, add addon price
						// 		if (eachAddon.mandatory_web == 'F') {
						// 			price += parseInt(eachAddon.aprice * eachAddon.qty)
						// 		}
						// 	}
						// }

						// //Keycards
						// if (eachTypeArray == 'skipass' && eachProductArray.addrlid) {
						// 	const selectedGuest = this.guests
						// 		? this.guests.filter(function (item) {
						// 				if (item.guestlid == eachProductArray.addrlid) {
						// 					return item
						// 				}
						// 		  })
						// 		: []
						// 	if (selectedGuest[0] && !selectedGuest[0].keynumber) {
						// 		price += eachProductArray.keycardPrice
						// 			? parseInt(eachProductArray.keycardPrice)
						// 			: 0
						// 	}
						// }

						// //Delivery cost (once)
						// if (eachTypeArray == 'skirental' && i == 0) {
						// 	if (this.cart.delivery) {
						// 		if (this.cart.deliveryPrice != -1) {
						// 			price += this.cart.deliveryPrice
						// 				? parseInt(this.cart.deliveryPrice)
						// 				: 0
						// 		}
						// 	}
						// }

						// //Insurance
						// if (
						// 	eachProductArray.insurance &&
						// 	eachProductArray.insurance == true
						// ) {
						// 	price += parseInt(
						// 		eachProductArray.priceWithInsurance - eachProductArray.price
						// 	)
						// }
					}
				}
			}

			return price
		},
		addIncurence() {
			this.insuranceModal = false
			store.dispatch('CART_COMPLETE_CANCELLATION', true)
			store.dispatch('TOGGLE_CART_ACCORDION', {
				showSkipass: false,
				showSkirental: false,
				showAccommodation: true,
				showSkischool: false,
				showActivities: false
			})
			setTimeout(() => {
				this.$scrollTo('#cancellation', 500, { offset: -100 })
			}, 200)
		},
		beforeConfirm() {
			const listOfAccommodation = this.cart.accommodation.filter(each => {
				return each.addons.filter(eachAddon => {
					return eachAddon.extraspoollid === 1 && eachAddon.qty !== 1
				}).length
			})

			if (listOfAccommodation.length) {
				this.insuranceModal = true
			} else {
				this.confirm()
			}
		},
		confirm() {
			this.loading = true
			this.insuranceModal = false

			store.dispatch('TOGGLE_CART_ACCORDION', {
				showSkipass: false,
				showSkirental: false,
				showAccommodation: false,
				showSkischool: false,
				showActivities: false
			})

			if (store.state.cart.cartCheckoutClicked == false) {
				store.dispatch('CART_CHECKOUT_CLICK', true)
			}

			store
				.dispatch('VALIDATE_PRODUCTS_IN_CART')
				.then(response => {
					if (response) {
						//Fast checkout
						if (store.state.cart.fastCheckout && !this.isLoggedIn()) {
							let cartWithoutUserId = Object.assign({}, store.state.cart)
							cartWithoutUserId.frontendprice = parseInt(
								this.totalPriceOf([
									'skipass',
									'skirental',
									'skischool',
									'accommodation',
									'activities'
								]).replace(/[^0-9.]/g, '')
							)

							this.goToPaymentModal = true
							store
								.dispatch('GET_PAYMENT', cartWithoutUserId)
								.then(success => {
									if (success) {
										if (!this.cart.resvid) {
											store.dispatch('GTM_PUSH_CHECKOUT_CART', this.cart)
										}

										store.dispatch('GET_CONFROMATION_ID', success.paymenturl)
										store.dispatch('EMPTY_CART')
										this.loading = false

										window.location.href = success.paymenturl
									} else {
										this.loading = false
										this.goToPaymentModal = false
									}
								})
								.catch(error => {
									window.console.error(error)
									this.loading = false
									this.goToPaymentModal = false
									store.dispatch('TOGGLE_GLOBAL_MODAL', {
										showCheckoutErrorModal: true
									})
								})

							//Normal checkout
						} else {
							let cartWithUserId = Object.assign({}, store.state.cart)
							cartWithUserId.customerlid = store.state.user.id
							cartWithUserId.frontendprice = parseInt(
								this.totalPriceOf([
									'skipass',
									'skirental',
									'skischool',
									'accommodation',
									'activities'
								]).replace(/[^0-9.]/g, '')
							)

							store.dispatch('REFRESH_TOKEN_BEFORE_REQUEST').then(response => {
								if (response) {
									this.goToPaymentModal = true
									store
										.dispatch('GET_PAYMENT', cartWithUserId)
										.then(success => {
											if (success) {
												if (!this.cart.resvid) {
													store.dispatch('GTM_PUSH_CHECKOUT_CART', this.cart)
												}

												store.dispatch(
													'GET_CONFROMATION_ID',
													success.paymenturl
												)
												store.dispatch('EMPTY_CART')
												this.loading = false

												window.location.href = success.paymenturl
											} else {
												this.loading = false
												this.goToPaymentModal = false
											}
										})
										.catch(error => {
											window.console.error(error)
											this.loading = false
											this.goToPaymentModal = false
											store.dispatch('TOGGLE_GLOBAL_MODAL', {
												showCheckoutErrorModal: true
											})
										})
								} else {
									this.loading = false
								}
							})
						}
					} else {
						this.loading = false
					}
				})
				.catch(error => {
					window.console.error(error)
					this.loading = false
					store.dispatch('TOGGLE_GLOBAL_MODAL', {
						showCheckoutErrorModal: true
					})
				})
		}
	}
}
</script>

<style scoped lang="scss">
$padding-small: 20px;
%cart-border {
	margin-bottom: $padding-small;
	padding-bottom: 10px;
	border-bottom: 1px solid $colorPrimary4;
}

.cart-overview {
	&__total-wrapper {
		text-align: center;
		img {
			max-width: 100%;
		}
	}
	&__profile {
		margin-top: 15px;
	}
	&__payment-options {
		margin-top: $padding-small;
	}
	&__total {
		background-color: #f7f8f9;
		padding: $padding-small;
	}
	&__total-title {
		@extend %cart-border;
		text-align: left;
	}
	&__total-id {
		font-size: 15px;
	}
	&__go-to-payment {
		// display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;

		padding-top: 20px;

		h4 {
			margin-bottom: 20px;
			margin-top: 20px;
		}

		p {
			margin-bottom: 20px;
		}

		div {
			button {
				margin: 20px 10px;
			}
		}

		.cart-overview__payment-options {
			margin-top: 40px;
		}

		@include for-tablet-portrait-up {
			display: flex;
			padding-top: 0;
		}
	}
	&__wrapper-acc {
		.cart-overview__total-acc {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			padding-bottom: 8px;
			margin-top: 8px;
			color: $colorGrey8;
			border-bottom: 1px solid $colorGrey3;

			&:last-child {
				border-bottom: none;
				padding-bottom: 0;
			}
		}
	}
	&__count {
		display: block;
		color: $colorPrimary5;
		font-size: 12px;
		line-height: 16px;
		text-align: left;
	}
	&__title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 200px;
		display: block;
	}
	&__payedamount {
		border-top: 1px solid $colorPrimary4;
		margin-top: 7px;
		padding: 10px 0;
		div {
			display: flex;
			justify-content: space-between;
			color: $colorPrimary;
			span {
				&:last-child {
					font-size: 17px;
				}
			}
			h4 {
				display: flex;
				width: 100%;
				justify-content: space-between;
				span {
					font-size: 14px;
					&:last-child {
						font-size: 22px;
					}
				}
			}
		}
	}
	&__total-price {
		border-top: 1px solid $colorPrimary4;
		margin: 9px 0 35px 0;
		padding-top: $padding-small;
		text-align: right;
		color: $colorPrimary;
	}
	&__booking-terms {
		text-align: left;
		margin: 0 0 20px 0;
	}
	&__payment-options {
		margin-top: $padding-small;
	}
	&__accommodation-price {
		text-align: right;
		h4 {
			margin-top: $padding-small;
			padding-top: 10px;
			border-top: $pale-blue-border;
		}
	}
	&__payment-info {
		padding: 10px;
		text-align: center;
		margin-top: 10px;
	}
}

.price {
	&--discount {
		color: #e15b5b;
	}
}
</style>
